import React from 'react';
import 'twin.macro';
import Button from '@teetsh/app/src/components/Buttons/Button';
import DeleteButton from '@teetsh/app/src/components/Buttons/DeleteButton';
import { TrashIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { ButtonWithConfirmation } from '@teetsh/app/src/components/ButtonWithConfirmation/ButtonWithConfirmation';

interface Props {
  closeModal: () => void;
  submitting: boolean;
  onDelete?: () => Promise<any>;
  dirty: boolean;
  hasValidationErrors: boolean;
}

export function ModalFooter(props: Props) {
  const { closeModal, onDelete, submitting, dirty, hasValidationErrors } =
    props;
  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <div tw="flex justify-end gap-2.5">
      {onDelete ? (
        <DeleteButton
          onClick={() => onDelete().then(() => closeModal())}
          popoverText={t('cahierJournal:actions.deleteSeanceWarning')}
          withConfirmation
          aria-label={t('cahierJournal:actions.deleteSeance')}
          large
          minimal
          icon={TrashIcon}
        />
      ) : (
        <div />
      )}
      <ButtonWithConfirmation
        withConfirmation={dirty}
        onConfirm={closeModal}
        bodyTitle={t('cahierJournal:seance.modal.closeWithoutSaving')}
        bodyDescription={t(
          'cahierJournal:seance.modal.closeWithoutSavingDetails',
        )}
        confirmButtonTitle={t('common:messages.dontSaveModification')}
        backButtonTitle={t('common:buttons.back')}
        popoverIntent="warning"
        large
      >
        {t('common:buttons.cancel')}
      </ButtonWithConfirmation>
      <Button
        loading={submitting}
        disabled={hasValidationErrors}
        large
        id="submit-event"
        intent="primary"
        type="submit"
      >
        {t('common:buttons.save')}
      </Button>
    </div>
  );
}
